import { PLATFORM } from 'aurelia-pal';

export function configure(config) {
	config.globalResources([
		PLATFORM.moduleName('./accounting-rules/accounting-rule-view'),
		PLATFORM.moduleName('./accounts/import/accounts-import'),
		PLATFORM.moduleName('./accounts/list/account-list'),
		PLATFORM.moduleName('./customers/reported-service-data-item-edit'),
		PLATFORM.moduleName('./customers/measured-services/select-measured-services'),
		PLATFORM.moduleName('./customers/organizational-units/organizational-unit-actions'),
		PLATFORM.moduleName('./customers/organizational-units/organizational-units'),
		PLATFORM.moduleName('./customers/organizational-units/organizational-unit-breadcrumb'),
		PLATFORM.moduleName('./customers/organizational-units/organizational-structure'),
		PLATFORM.moduleName('./customers/global-customer'),
		PLATFORM.moduleName('./customers/selected-customer-link'),
		PLATFORM.moduleName('./defaultMeasures/default-measure-edit'),
		PLATFORM.moduleName('./defaultMeasures/scope-type-group-select'),
		PLATFORM.moduleName('./measures/measures-input-container'),
		PLATFORM.moduleName('./services/service-structure'),
		PLATFORM.moduleName('./municipalities/customer-municipality-list'),
		PLATFORM.moduleName('./services/service-actions'),
		PLATFORM.moduleName('./services/service-targetings/service-targeting'),
		PLATFORM.moduleName('./scopes/scope-type-select'),
		PLATFORM.moduleName('./scopes/scope-list-hover'),
		PLATFORM.moduleName('./home/dashboard-quick-search'),
		PLATFORM.moduleName('./services/service-structure-management'),
		PLATFORM.moduleName('./customers/organizational-units/organizational-unit-management'),
		PLATFORM.moduleName('./financial-entries/financial-entries-container'),
		PLATFORM.moduleName('./imports/import-container'),
		PLATFORM.moduleName('./imports/import-entry-container'),
		PLATFORM.moduleName('./imports/import-progress'),
		PLATFORM.moduleName('./imports/dashboard-import-list'),
		PLATFORM.moduleName('./imports/components/data-copy'),
		PLATFORM.moduleName('./reporting/new-report-container'),
		PLATFORM.moduleName('./reporting/report-list'),
		PLATFORM.moduleName('./reporting/report-view'),
		PLATFORM.moduleName('./reporting/untargeted-financial-entries'),
		PLATFORM.moduleName('./accounting-dimensions/accounting-dimensions'),
		PLATFORM.moduleName('./users/user-entry-buttons'),
		PLATFORM.moduleName('./reporting/reporting-app'),
		PLATFORM.moduleName('./admin/measures/measures-app'),
	]);
}
